import type { ReactNode } from 'react'
import { cx } from '../cx'
import s from './Stack.module.css'

export type Gap = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl'

/** Things one above the other, evenly spaced. The default way to lay out a screen's sections. */
export function Stack(props: {
  children: ReactNode
  gap?: Gap
  /** Line children up at the start instead of stretching them across. */
  align?: 'stretch' | 'start' | 'center'
  as?: 'div' | 'section' | 'ul' | 'ol'
  label?: string
}) {
  const Tag = props.as ?? 'div'
  return (
    <Tag className={cx(s.stack, s[`gap-${props.gap ?? 'md'}`], props.align && s[`align-${props.align}`])} aria-label={props.label}>
      {props.children}
    </Tag>
  )
}
